<script>
	import Chart from 'chart.js/auto';
	import { onMount } from 'svelte';

	export let config;
	let ctx;
	let chartCanvas;

	onMount(async (promise) => {
		ctx = chartCanvas.getContext('2d');
		new Chart(ctx, config);
	});
</script>

<canvas bind:this={chartCanvas} id="myChart" />
